export const scrollToFirstOnValidationErrors = async (btnSelector) => {
  const btn = document.getElementById(btnSelector);
  const element = document.getElementsByClassName('invalid-feedback')[0];
  if (element) {
    btn.addEventListener('click', () => {
      element.scrollIntoView({ block: 'end' });
    });
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const showNotification = ({
  ctx, variant, title, message,
}) => {
  ctx.$bvToast.toast(message, {
    title,
    variant,
    autoHideDelay: 2000,
    appendToast: true,
  });
};
